import { FeatureType } from "interfaces/feature-tracker";
import { baseApi } from "../api";

const featureType = FeatureType.CLUB_GIFT_BONUS_V2;

export const clubGiftsGaloreAPI = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		updatePopupState: builder.mutation({
			query: (arg) => {
				const queryParams = new URLSearchParams();
				for (const key in arg.body) {
					queryParams.append(key, arg.body[key]);
				}
				return {
					url: `/rest/${featureType}/tracker/user/${
						arg.popupType
					}?${queryParams.toString()}`,
					method: "POST"
				};
			},
			invalidatesTags: () => [{ type: "featureTrackerTag", id: featureType }]
		}),
		simulatePurchase: builder.mutation({
			query: (arg) => {
				const queryParams = new URLSearchParams();
				for (const key in arg.body) {
					queryParams.append(key, arg.body[key]);
				}
				return {
					url: `/rest/debug/${featureType}/simulate/purchase?${queryParams.toString()}`,
					method: "POST"
				};
			},
			invalidatesTags: () => [{ type: "featureTrackerTag", id: featureType }]
		}),
		simulatePurchases: builder.mutation({
			query: (arg) => {
				const queryParams = new URLSearchParams();
				for (const key in arg.body) {
					queryParams.append(key, arg.body[key]);
				}
				return {
					url: `/rest/debug/${featureType}/simulate/purchases?${queryParams.toString()}`,
					method: "POST"
				};
			},
			invalidatesTags: () => [{ type: "featureTrackerTag", id: featureType }]
		})
	})
});

export const {
	useUpdatePopupStateMutation,
	useSimulatePurchaseMutation,
	useSimulatePurchasesMutation
} = clubGiftsGaloreAPI;
